import styled from "@emotion/styled";
import { ToggleButton } from "react-aria-components";
import { MDSToggleButtonVariant } from "./toggle-button.types";

interface StyledToggleButtonProps {
  variant?: MDSToggleButtonVariant;
}

export const StyledToggleButton = styled(ToggleButton)<StyledToggleButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xs};
  cursor: pointer;
  border: none;
  outline: none;
  font-weight: ${({ theme }) => theme.fontWeights.smedium};
  font-size: ${({ theme }) => theme.fontSizes["text-s"]};
  line-height: ${({ theme }) => theme.lineHeights["text-s"]};
  transition: all 0.15s ease;

  ${({ variant = MDSToggleButtonVariant.Default, theme }) => {
    switch (variant) {
      case MDSToggleButtonVariant.Pill:
        return `
          border-radius: 50px;
          padding: ${theme.spacing.md} ${theme.spacing.md};
          background: ${theme.colors.mblue.x200};
          /* match the theme when harvest comes */
          color: ${theme.colors.mblue.x600};
          gap: ${theme.spacing.sm};

          &:hover {
            background: ${theme.colors.mblue.x300};
          }

          &[data-selected] {
            background: ${theme.colors.mblue.x300};
            color: ${theme.colors.mblue.x700};
          }

          &[data-selected]:hover {
            background: ${theme.colors.mblue.x400};
          }

          svg {
            color: ${theme.colors.mblue.x600};
          }
        `;

      case MDSToggleButtonVariant.Default:
      default:
        return `
          border-radius: 6px;
          border: 1px solid ${theme.colors.border.default};
          background: ${theme.colors.surface.menu};
          color: ${theme.colors.text.tertiary};
          padding: ${theme.spacing.sm};

          &[data-selected] {
            background: ${theme.colors.background.button.chip.default};
            color: ${theme.colors.text.primary};
          }
        `;
    }
  }}

  z-index: 1;

  &[data-disabled] {
    z-index: 0;
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[data-focus-visible] {
    z-index: 2;
    outline: 2px solid ${({ theme }) => theme.colors.mblue.x400};
    outline-offset: 2px;
  }
`;
